import React from 'react';
import { Layout, Row, Col } from 'antd';
import { Icon } from 'semantic-ui-react';
import '../components/FooterContent.css';

const { Footer } = Layout;

function FooterContent() {
  return (
    <Footer className="footer">
      <Row justify="space-around">
        <Col span={6}  className='info-container'>
          <div className='location-icon-container'>
            <Icon name='building' size='big' />
            <h4>北京市朝阳区东三环北路5号北京发展大厦1501</h4>
          </div>
        </Col>
        <Col span={10}  className='phone-container'>
          <div className='phone-icon-container'>
            <Icon name='phone' size='large' />
            <h4>010-6590 6290</h4>
          </div>
        </Col>
        <Col span={6}  className='website-container'>
          <div className='website-icon-container'>
            <Icon name='location arrow' size='large' />
            <h4>harscorail.com.cn</h4>
          </div>
        </Col>
      </Row>
      
      <Row className="footer-row">
        <Col span={24}>
          <div>
            ©2024 哈斯科亚太铁路机械商贸（北京）有限公司
          </div>
        </Col>
      </Row>
    </Footer>
  );
}

export default FooterContent;